import { _ } from "../polyglot/polyglot.js";

/**
 * Return a translated version of the provided server error message
 * when uploading files.
 *
 * @param {string} message - Server's error message
 */
export function convertServerUploadFileErrorMessage({ message }) {
	if (message === "File type not allowed.")
		return _("The selected file type is not allowed.");

	if (message === "File may contain a virus.")
		return _("The selected file may contain a virus.");

	return _("The upload failed");
}
